import { useContext, useEffect } from "react";
import { useNavigate } from "react-router";

import { UserSessionContext } from "../../use-user-context";

export type LogoutProps = object;

export const Logout: React.FC<LogoutProps> = () => {
  const [, setUserSession] = useContext(UserSessionContext);
  const navigate = useNavigate();

  useEffect(() => {
    setUserSession({ active: false });
    navigate("/");
  });

  return null;
};
